// NZDOC booking strategy.
//
// The NZDOC scanner writes a site-specific reservation URL into
// `site.reserveUrl` (e.g. bookings.doc.govt.nz/Web/Default.aspx?page=AssetBooking
// &assetId=...). The site identity is already encoded in the URL; date and
// party-size pickers are filled on the booking site itself. So we passthrough.
//
// V1 consumer note: This strategy is the contract for GET /api/v1/stay
// against identifierType=hutbagger_hut. The describeBookingInputs output is
// what the public API surfaces to consumers, so keep it precise.

export default {
  buildBookingUrl({ site }) {
    return site.reserveUrl;
  },

  buildPreviewUrl(site) {
    return site.reserveUrl;
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes:
            "Required for the consumer to know which night they're booking, but not encoded in the URL — the user selects dates on the NZDOC booking page.",
        },
        departureDate: {
          status: "required",
          notes:
            "Required for the consumer to know which night they're booking, but not encoded in the URL — the user selects dates on the NZDOC booking page.",
        },
        ref: {
          status: "ignored",
          notes:
            "NZDOC uses site.reserveUrl directly; ref is not encoded in the URL.",
        },
        partySize: {
          status: "ignored",
          defaultValue: 1,
          notes:
            "Party size is not encoded in the NZDOC booking URL; the user selects it on the booking page.",
        },
      },
    };
  },
};
